/** Keep invitation code exchange and routing under the completion flow's control. */
export function appAuthCallbackOptions(defaultRedirectUri: string) {
    const invitationCallback = window.location.pathname.replace(/\/$/, '') === '/invitation/complete';
    return {
        redirectUrl: invitationCallback ? `${window.location.origin}/invitation/complete` : defaultRedirectUri,
        triggerAuthorizationResultEvent: invitationCallback
    };
}

/** Native invitation action returns are not callbacks for an Aurora OAuth request. */
export function isNativeInvitationRedirect(currentUrl: string, authority: string): boolean {
    const params = new URL(currentUrl).searchParams;
    return (
        !params.has('state') && !params.has('error') && !!params.get('session_state') && params.get('iss') === authority
    );
}
